export enum GROUP {
  UNIVERSALBAR_TOOLS = 'UniversalBar/Tools',
  TOOLS = 'tools',
  MEMBERSHIP = 'membership',
  NOTIFICATION_BELL = 'NotificationBell'
}
